import React, { useState, useEffect } from 'react';
import ChartHub from './ChartHub';
import InspectionsSummaryReport from './InspectionsSummaryReport';
import ImageHub from './ImageHub';
import ToggleSwitchWithText from 'components/ToggleSwitchWithText';
import Loader from 'components/Loader';
import type { InspectionSelection } from '../assetHubInspectionSelection';
import type { AssetInspectionRecord } from 'actions/asset';
import type { MergedInspectionReport } from 'customHooks/useFetchInspectionReports';

type AssetHubOptionsProps = {
  FAKE_BRIDGES: Array<{ name: string; src: string }>;
  id: number;
  assetHubRefreshToken: number;
  wasAssetHubRefreshLoading: boolean;
  selectedInspection: InspectionSelection | null;
  onInspectionSelect: React.Dispatch<
    React.SetStateAction<InspectionSelection | null>
  >;
  readonly inspectionRecords: readonly AssetInspectionRecord[];
  readonly inspectionsAvailable: boolean;
  readonly inspectionRecordsLoading: boolean;
  readonly inspectionRecordsError: boolean;
  readonly inspectionReports: readonly MergedInspectionReport[];
  readonly reportsLoading: boolean;
  readonly reportsError: boolean;
};

const ASSET_HUB_OPTIONS = [
  { value: 'Charts', label: 'Charts' },
  { value: 'Report', label: 'Report' },
  // { value: 'Images', label: 'Images' },
];

const AssetHubOptions: React.FC<AssetHubOptionsProps> = ({
  FAKE_BRIDGES,
  id,
  assetHubRefreshToken,
  wasAssetHubRefreshLoading,
  selectedInspection,
  onInspectionSelect,
  inspectionRecords,
  inspectionRecordsLoading,
  inspectionRecordsError,
  inspectionReports,
  reportsLoading,
  reportsError,
}) => {
  const [selectedAssetHub, setSelectedAssetHub] = useState<string>('Charts');
  const [requestType, setRequestType] = useState<string>('inspections');

  useEffect(() => {
    if (selectedInspection) {
      setSelectedAssetHub('Report');
    }
  }, [selectedInspection]);

  const onChangeAssetHub = (sp: string) => {
    setSelectedAssetHub(sp);
  };

  const onChangeRequestType = (sp: string) => {
    setRequestType(sp);
  };

  const filteredOptions = ASSET_HUB_OPTIONS;

  const containerClass = 'xa_asset_hub--options_container';

  if (!selectedAssetHub) {
    return <Loader />;
  }

  return (
    <div className={containerClass}>
      <div className="xa_asset_hub--options-select">
        {selectedAssetHub === 'Charts' && (
          <select
            name="assetHub"
            id="assetHub"
            value={requestType}
            onChange={(e) => onChangeRequestType(e.target.value)}
            style={{width:'33.3%'}}
          >
            <option value="inspections">Inspection Breakdown</option>
            <option value="treatments">Treatment Breakdown</option>
          </select>
        )}
        <ToggleSwitchWithText
          onChange={onChangeAssetHub}
          options={filteredOptions}
          selectedValue={selectedAssetHub}
          name="change_assetHub"
        />
      </div>
      <div className="xa_asset_hub--content">
        {selectedAssetHub === 'Charts' ? (
          <div className="xa_asset_hub--pane xa_asset_hub--pane_active">
            <ChartHub
              id={id}
              requestType={requestType}
              assetHubRefreshToken={assetHubRefreshToken}
              wasAssetHubRefreshLoading={wasAssetHubRefreshLoading}
              inspectionRecords={inspectionRecords}
              recordsLoading={inspectionRecordsLoading}
              recordsError={inspectionRecordsError}
              inspectionReports={inspectionReports}
              reportsLoading={reportsLoading}
              reportsError={reportsError}
            />
          </div>
        ) : null}
        {selectedAssetHub === 'Report' ? (
          <div className="xa_asset_hub--pane xa_asset_hub--pane_active">
            <InspectionsSummaryReport
              assetId={id}
              assetHubRefreshToken={assetHubRefreshToken}
              selectedInspection={selectedInspection}
              onInspectionSelect={onInspectionSelect}
              inspectionRecords={inspectionRecords}
              recordsLoading={inspectionRecordsLoading}
              recordsError={inspectionRecordsError}
              inspectionReports={inspectionReports}
              reportsLoading={reportsLoading}
              reportsError={reportsError}
            />
          </div>
        ) : null}
      </div>
      {selectedAssetHub === 'Images' && <ImageHub images={FAKE_BRIDGES} />}
    </div>
  );
};

export default AssetHubOptions;
